export const FETCH_SERVICES = {
    REQUEST: 'FETCH_SERVICES_REQUEST',
    SUCCESS: 'FETCH_SERVICES_SUCCESS',
    FAILED: 'FETCH_SERVICES_FAILED',
};
